/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { L as isWindvane } from './index-f24a9ec1.js';
import { JSCall } from './bridges/windvane/index.js';

/**
 * @description windvane promise
 * @param moduleName 模块名称
 * @param apiName 方法名
 * @param params 其他参数
 * @param overtime windVane响应超时时间, 默认5s超时, 需要禁用可传null
 */
var promiseWindVane = function (moduleName, apiName, params, extraParams) {
    if (extraParams === void 0) { extraParams = { overtime: 5000 }; }
    return new Promise(function (resolve) {
        if (!isWindvane) {
            resolve({ success: false, message: 'no windvane found' });
            return;
        }
        /**
         * 增加超时
         * 防止有些客户端 windVane 方法无响应
         */
        var timer = 0;
        if (extraParams === null || extraParams === void 0 ? void 0 : extraParams.overtime) {
            timer = window.setTimeout(function () {
                resolve({ success: false, message: 'promiseWindVane timeout' });
            }, extraParams === null || extraParams === void 0 ? void 0 : extraParams.overtime);
        }
        try {
            JSCall("".concat(moduleName, ".").concat(apiName), params, function (res) {
                clearTimeout(timer);
                resolve({ success: true, data: res.data, originalData: res });
            }, function (e) {
                clearTimeout(timer);
                resolve({ success: false, message: e.message });
            });
        }
        catch (e) {
            clearTimeout(timer);
            resolve({
                success: false,
                message: e instanceof Error ? e.message : 'expectation failed',
            });
        }
    });
};

export { promiseWindVane as p };
